// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { withState, compose } from '../../../node_module_clones/recompose';
import classNames from 'classnames';
import { isEmpty } from 'lodash/fp';

// Styles
import './Tabs.scss';

const TabList = ({ activeTab, tabs, setTab }) => {
    if (isEmpty(tabs)) return null;

    return (
        <div className="TabList">
            {tabs.map((tab) =>
                React.cloneElement(tab, {
                    key: tab.props.tabId,
                    activeTab,
                    setTab,
                }),
            )}
        </div>
    );
};

TabList.propTypes = {
    tabs: PropTypes.array,
    activeTab: PropTypes.string,
    setTab: PropTypes.func,
};

const enhance = compose(withState('activeTab', 'setTab', ({ initialActiveTab }) => initialActiveTab));

const Tabs = ({ className, children, activeTab, tabs, setTab, footer }) => (
    <div className={classNames('Tabs', className)}>
        <TabList activeTab={activeTab} tabs={tabs} setTab={setTab} />
        <div className="tab-panels" data-scrollable>
            {children(activeTab)}
        </div>
        {footer && footer(activeTab)}
    </div>
);

Tabs.propTypes = {
    children: PropTypes.func.isRequired,
    footer: PropTypes.func,
    className: PropTypes.string,
    initialActiveTab: PropTypes.string,
    tabs: PropTypes.array,
    activeTab: PropTypes.string,
    setTab: PropTypes.func,
};

export default enhance(Tabs);
